'use strict';

const { getCookie } = require('../../common');
const AuthModel = require("../models/authModel");

class AuthController extends AuthModel {
  constructor() {
    super();
    this.saveName = "amzti";
  }
  sendRequest() {
    return this.request().then(response => {
      if (response.status === 200) {
        return response.json();
      } else {
        throw response;
      }
    });
  }
  saveInLocal(token, id) {
    if (token && id) {
      const data = [btoa(token), btoa(id)];
      localStorage.setItem(this.saveName, JSON.stringify(data));
    } else {
      throw new Error('Undefined Token or Id');
    }
  }
  checkLocal() {
    const currentToken = getCookie('h');
    const currentSave = localStorage.getItem(this.saveName);

    if (currentSave && currentToken) {
      const parsed = JSON.parse(currentSave);
      const savedToken = atob(parsed[0]);
      return savedToken === currentToken ? atob(parsed[1]) : null
    }
  }

}

module.exports = AuthController;
